





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class GeneralSettings extends Vue {
    private created() {
        this.$store.state.mobileSidebarVisible = false;
    }

    @Watch('$store.state.colors.mainColor')
    private onPropertyChanged(value: string, oldValue: string) {
        document.documentElement.style.setProperty('--theme-color', this.$store.state.colors.mainColor);
        localStorage.setItem('mainColor', this.$store.state.colors.mainColor);
    }

    @Watch('$store.state.colors.accentColor')
    private onPropertyChanged1(value: string, oldValue: string) {
        document.documentElement.style.setProperty('--accent-color', this.$store.state.colors.accentColor);
        localStorage.setItem('accentColor', this.$store.state.colors.accentColor);
    }
}
